import { mapCursorPlugin } from './mapCursorPlugin.js';
import { panelMapClickSelectionPlugin } from './panelMapClickSelectionPlugin.js';
import { panelTranslateModifyPlugin } from './panelTranslateModifyPlugin.js';
import { panelCtrlDragCopyPlugin } from './panelCtrlDragCopyPlugin.js';
import { panelPasteClickPlugin } from './panelPasteClickPlugin.js';
import { panelCopyPasteKeyboardPlugin } from './panelCopyPasteKeyboardPlugin.js';

/** 패널 플래닝 기본 맵 플러그인 (순서 = attach 순서) */
export const DEFAULT_PANEL_PLANNING_MAP_PLUGINS = [
  panelTranslateModifyPlugin,
  mapCursorPlugin,
  panelMapClickSelectionPlugin,
  panelCtrlDragCopyPlugin
];

/** Ctrl+C/V 붙여넣기 — 기본 목록 제외, 필요 시 attachPanelPlanningMapPlugins에 전달 */
export const OPTIONAL_PANEL_KEYBOARD_PASTE_PLUGINS = [
  panelCopyPasteKeyboardPlugin,
  panelPasteClickPlugin
];

/**
 * 결함 맵 클릭 — 기본 목록 제외.
 * `@/features/defect` 의 attachDefectMapFeature(mapHost, ctx) 로 개별 부착·제거 권장.
 */
export { defectModuleClickPlugin, DEFECT_MODULE_CLICK_PLUGIN_ID } from '@/features/defect';

/**
 * @param {import('../OpenLayersMapHost').OpenLayersMapHost} host
 * @param {object} ctx — createPanelPlanningMapPluginContext(vm)
 * @param {Array<{ id: string, attach: Function }>} [plugins]
 */
export function attachPanelPlanningMapPlugins(
  host,
  ctx,
  plugins = DEFAULT_PANEL_PLANNING_MAP_PLUGINS
) {
  if (!host) {
    return;
  }
  plugins.forEach(plugin => {
    host.attachPlugin(plugin, ctx);
  });
}

export {
  mapCursorPlugin,
  panelMapClickSelectionPlugin,
  panelTranslateModifyPlugin,
  panelPasteClickPlugin,
  panelCopyPasteKeyboardPlugin,
  panelCtrlDragCopyPlugin
};
